import axios from "axios"
import { authHeader, baseUrl } from "../../utils"
import { ACADEMIC_DASHBOARD_ERROR, GETTING_ACADEMIC_DASHBOARD, GET_ACADEMIC_DASHBOARD } from "../types"

export const fetchAcademicDashboardData = () => async (dispatch) => {    
    try{
        const headers = authHeader()

        dispatch({
            type: GETTING_ACADEMIC_DASHBOARD,
            payload: true
        })

        const response = await axios.get(`${baseUrl}/dashboards/academic`, { headers })
        
        dispatch({
            type: GET_ACADEMIC_DASHBOARD,
            payload: response.data.data
        })
        
    }
    catch(error){
        dispatch({
            type: ACADEMIC_DASHBOARD_ERROR,
            error
        })
    }
}
